import { common } from '@project/api/common/v1'
import { home } from '@project/api/home/v1'
import { star, starEvents } from '@project/api/star/v1'
import { bySlug as getTeam } from '@project/api/team/v1'
import { byID as getStaffMember } from '@/project/api/staff-member/v1'
import { byID as getJob } from '@project/api/job-opening/v1'
import { bySlug as getLocation } from '@project/api/location/v1'
import { paginate as paginateNews, total as totalNews } from '@project/api/news/v1'
import { paginate as paginateJobs, total as totalJobs } from '@project/api/job-opening/v1'
import { aboutUs } from '@project/api/about-us/v1'
import { covid19 } from '@project/api/covid-19/v1'
import { bySlug as getNews } from '@project/api/news/v1'
import { contactPage } from '@project/api/contact-page/v1'

export default {
  async common() {
    return await common()
  },
  async home() {
    return await home()
  },
  async contactUs() {
    return await contactPage()
  },
  async team(slug) {
    return getTeam(slug)
  },
  async staffMember(id) {
    return getStaffMember(id)
  },
  async location(slug) {
    return getLocation(slug)
  },
  async star() {
    return star()
  },
  async jobs({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateJobs(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async job(id) {
    return getJob(id)
  },
  async totalJobs() {
    return totalJobs()
  },
  async news({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateNews(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async newsStory(slug) {
    return getNews(slug)
  },
  async totalNews() {
    return totalNews()
  },
  async aboutUs() {
    return aboutUs()
  },
  async covid19() {
    return covid19()
  },
  async starEvents() {
    return starEvents()
  }
}

